// extracted by mini-css-extract-plugin
module.exports = {"Login":"LoginPage_Login__1ixHR","Submitbutton":"LoginPage_Submitbutton__1hVtx"};